import {
	Box,
	Button,
	CircularProgress,
	CircularProgressProps,
	Dialog,
	DialogActions,
	DialogContent,
	DialogContentText,
	DialogTitle,
	Unstable_Grid2 as Grid,
	Stack,
	Typography,
} from '@mui/material';
import { useEffect, useState } from 'react';
import { useKioskRouter } from '../../utils/useKioskRouter';
import { StepType } from './steps';
import { KioskElectronStoreState } from '@kinderlabs-pos/state';
import { useConfirm } from '@kinderlabs-pos/ui-components';
import { ArrowRightOutlined } from '@ant-design/icons';
import { KioskType } from '@kinderlabs-pos/shared-data-type';
import { WithDialog } from '@kinderlabs-pos/ui-atoms';
import Member1ImageTop from '../../assets/member_1_t.jpg';
import Member1ImageBottom from '../../assets/member_1_b.jpg';
import Member2Image from '../../assets/member_2_t.jpg';

export const UserInfoPageHeader = ({
	curStep,
	kioskType,
}: {
	curStep: StepType;
	kioskType: KioskType | 'ONLINE-TICKETS';
}) => {
	const { navigate홈으로 } = useKioskRouter();
	const { data: KioskElectronStore } = KioskElectronStoreState.useKioskMainPageLocalSettings();
	const customConfirm = useConfirm();

	return (
		<Stack>
			{curStep === '전화번호' && (
				<Stack sx={{ width: '100%', height: 400 }}>
					<img
						src={Member1ImageTop}
						style={{ width: '100%', height: '100%', objectFit: 'contain' }}
					/>
				</Stack>
			)}
			{curStep === '이용약관' && (
				<Stack sx={{ width: '100%', height: 300 }}>
					<img
						src={Member2Image}
						style={{ width: '100%', height: '100%', objectFit: 'contain' }}
					/>
				</Stack>
			)}
		</Stack>
	);
};

export const UserInfoPageBottom = ({
	curStep,
	kioskType,
}: {
	curStep: StepType;
	kioskType: KioskType | 'ONLINE-TICKETS';
}) => {
	const { navigate홈으로 } = useKioskRouter();
	const { data: KioskElectronStore } = KioskElectronStoreState.useKioskMainPageLocalSettings();
	const customConfirm = useConfirm();

	return (
		<Stack>
			{curStep === '전화번호' && (
				<Stack sx={{ width: '100%', height: 300 }}>
					<img
						src={Member1ImageBottom}
						style={{ width: '100%', height: '100%', objectFit: 'contain' }}
					/>
				</Stack>
			)}
		</Stack>
	);
};

export const CircularProgressWithlabel = ({
	onTimeoutCallback,
	timeout,
	onClick,
	...others
}: CircularProgressProps & {
	timeout: number;
	onTimeoutCallback: () => void;
}) => {
	const [seconds, setSeconds] = useState(timeout);

	useEffect(() => {
		const mouseEvent = (event: MouseEvent) => {
			setSeconds(timeout);
		};

		const keyDownEvent = (event: KeyboardEvent) => {
			setSeconds(timeout);
		};

		window.addEventListener('mousedown', mouseEvent);
		window.addEventListener('keydown', keyDownEvent);

		return () => {
			window.removeEventListener('mousedown', mouseEvent);
			window.removeEventListener('keydown', keyDownEvent);
		};
	}, []);

	useEffect(() => {
		const interval = setInterval(() => setSeconds((prev) => prev - 1), 1000 * 1);

		return () => clearInterval(interval);
	}, []);

	useEffect(() => {
		if (seconds === 0) onTimeoutCallback();
	}, [seconds]);

	return (
		<Box
			sx={{ position: 'relative', display: 'inline-flex' }}
			onClick={onClick}>
			<CircularProgress
				{...others}
				variant='determinate'
				value={(100 * seconds) / timeout}
			/>
			<Box
				sx={{
					top: 0,
					left: 0,
					bottom: 0,
					right: 0,
					position: 'absolute',
					display: 'flex',
					alignItems: 'center',
					justifyContent: 'center',
				}}>
				<Typography
					variant='body2'
					component='div'
					color='primary'>
					{seconds}
				</Typography>
			</Box>
		</Box>
	);
};
